var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "4c76448e94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 157 L 375 157 L 375 218.9375 L 0 218.9375 Z M 0 157 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4c76448e94)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 125.359375 218.527344 C 85.273438 217.019531 19.488281 206.480469 0 167.402344 C 2.519531 167.582031 4.386719 170.546875 6.089844 172.242188 C 10.53125 178.6875 19.296875 179.636719 26.230469 182.023438 C 91.039062 198.734375 157.777344 186.714844 221.507812 171.101562 C 243.980469 165.9375 266.589844 161.035156 289.585938 158.898438 C 304.082031 157.683594 318.988281 155.972656 333.175781 160.148438 C 343.351562 163.570312 353.367188 168.601562 361.851562 175.183594 C 366.695312 180.085938 374.300781 185.542969 375.007812 192.585938 C 372.152344 193.253906 368.917969 189.761719 365.996094 189.6875 C 346.996094 184.6875 327.445312 186.09375 308.121094 188.21875 C 246.738281 195.128906 187.644531 219.011719 125.359375 218.527344 Z M 125.359375 218.527344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logoWhite.fe6aa097b51ba098cf5bc5de3ef1b0b1.svg";
export { ForwardRef as ReactComponent };